export const SET_THEME_DATA = '[Theme] set theme data';

export const setThemeData = (themeShortCode: string, data: any) => ({
  type: SET_THEME_DATA,
  payload: { themeShortCode, data },
});

class SetThemeData {
  readonly type = SET_THEME_DATA;
  constructor(public payload: { themeShortCode: string; data: any }) {}
}

export type ThemeActionTypes = SetThemeData;
